import _ from "underscore";

import Backbone from "pages/common/lib/backbone-helpers";
import Constants from "const/constants";

var FileCollection = Backbone.Collection.extend({
    constants: {
        STATUS: {
            UPLOADING: `uploading`,
            UPLOADED: `uploaded`,
            VALIDATING: `validating`,
            VALID: `valid`,
            INVALID: `invalid`
        }
    },

    initialize: function (models, options) {
        options = !_.isUndefined(options) ? options : {};

        if (options.type) {
            this.type = options.type;
        }

        if (options.dimensions) {
            this.dimensions = options.dimensions;
        }

        if (options.validExtensions) {
            this.validExtensions = options.validExtensions;
        }

        if (options.aspectRatio) {
            this.aspectRatio = options.aspectRatio;
        }

        if (options.uploadType) {
            this.uploadType = options.uploadType;
        }

        this.uploadCount = 0;
        this.listenTo(this, `change:status`, this.onFileStatusChange);
        this.listenTo(this, `add`, this.onFileUploadStart);
        this.listenTo(this, `remove`, this.onFileRemove);

        _.bindAll(this, `model`);
    },

    modelId: function (attrs) {
        return attrs.id;
    },

    getFiles: function () {
        var _this = this;
        return this.filter(function (file) {
            return file.get(`status`) === _this.constants.STATUS.VALID;
        }).map(function (file) {
            return file.toJSON();
        });
    },

    onFileStatusChange: function (model) {
        switch (model.get(`status`)) {
            case this.constants.STATUS.VALID:
            case this.constants.STATUS.INVALID:
                if (this.uploadCount > 0) {
                    this.uploadCount--;
                }
                break;
        }
        this.trigger(`upload:count`, this.uploadCount);
    },

    onFileUploadStart: function (model) {
        if (
            model.get(`status`) !== this.constants.STATUS.VALID &&
            model.get(`status`) !== this.constants.STATUS.INVALID
        ) {
            this.uploadCount++;
            this.trigger(`upload:count`, this.uploadCount);
        }
    },

    onFileRemove: function (model) {
        if (
            model.get(`status`) !== this.constants.STATUS.VALID &&
            model.get(`status`) !== this.constants.STATUS.INVALID
        ) {
            if (this.uploadCount > 0) {
                this.uploadCount--;
            }
        }
        this.trigger(`upload:count`, this.uploadCount);
    },

    isMezzanineUpload: function () {
        return this.uploadType === Constants.UPLOAD_TYPE.MEZZANINE;
    }
});

export default FileCollection;
